import React from 'react';
import { Code, Cloud, Brain, ArrowRight } from 'lucide-react';

const Solutions = () => {
  const solutions = [
    {
      icon: Code,
      title: 'Desarrollo de Software',
      description: 'Creamos soluciones personalizadas que impulsan la innovación y transforman tus ideas en aplicaciones robustas y escalables.',
      image: 'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6',
      features: [
        'Desarrollo de aplicaciones web y móviles',
        'Arquitectura de microservicios',
        'Integración de sistemas legacy',
        'DevOps y CI/CD'
      ],
      color: 'from-orange-50 to-gray-50'
    },
    {
      icon: Cloud,
      title: 'Gestión de Nubes',
      description: 'Optimizamos tu infraestructura cloud con estrategias que mejoran la eficiencia, reducen costos y aseguran escalabilidad.',
      image: 'https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg',
      features: [
        'Migración a la nube (AWS, Azure, GCP)',
        'Optimización de costos cloud',
        'Arquitecturas multi-cloud',
        'Monitoreo y seguridad 24/7'
      ],
      color: 'from-white to-orange-50'
    },
    {
      icon: Brain,
      title: 'Inteligencia Artificial',
      description: 'Implementamos soluciones de IA que automatizan procesos, predicen tendencias y generan valor a partir de tus datos.',
      image: 'https://images.unsplash.com/photo-1697577418970-95d99b5a55cf',
      features: [
        'Machine Learning y Deep Learning',
        'IA Generativa y LLMs',
        'Computer Vision y NLP',
        'Análisis predictivo y optimización'
      ],
      color: 'from-orange-50 to-white'
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-gradient-to-b from-gray-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Soluciones que impulsan tu empresa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transformamos desafíos en oportunidades con tecnología de vanguardia
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="space-y-12">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            return (
              <div 
                key={index}
                className={`group relative bg-gradient-to-br ${solution.color} rounded-2xl overflow-hidden border border-gray-200 hover:border-[#ff6b35] transition-all duration-500 hover:shadow-2xl hover:shadow-[#ff6b35]/20`}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-white/50"></div>
                
                <div className={`relative grid md:grid-cols-2 gap-8 p-8 md:p-12 ${
                  index % 2 === 0 ? '' : 'md:grid-flow-dense'
                }`}>
                  {/* Content */}
                  <div className={`flex flex-col justify-center ${
                    index % 2 === 0 ? '' : 'md:col-start-2'
                  }`}>
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ff6b35]/20 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-[#ff6b35]" />
                    </div>
                    
                    <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                      {solution.title}
                    </h3>
                    
                    <p className="text-lg text-gray-600 mb-6">
                      {solution.description}
                    </p>
                    
                    <ul className="space-y-3 mb-8">
                      {solution.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-3 text-gray-700">
                          <div className="w-1.5 h-1.5 bg-[#ff6b35] rounded-full"></div>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    
                    <button className="group/btn inline-flex items-center gap-2 text-[#ff6b35] font-semibold hover:gap-4 transition-all duration-300">
                      Conocer más
                      <ArrowRight className="w-5 h-5" />
                    </button>
                  </div>

                  {/* Image */}
                  <div className={`relative ${
                    index % 2 === 0 ? '' : 'md:col-start-1 md:row-start-1'
                  }`}>
                    <div className="relative h-full min-h-[300px] rounded-xl overflow-hidden">
                      <img 
                        src={solution.image}
                        alt={solution.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-br from-orange-50/30 to-transparent"></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Solutions;